import { BUILD, ORDERED_OPTIONS } from '@consts/index'
import { FilterOption } from 'types/filters'
import { Collection } from 'types/collection'
import { ProductFeed } from 'types/product'

export function getCollectionFiltersState(
  selectedFilterOptions: FilterOption[],
  fitAttribute: string,
  selectedOption: string,
  allowMultiple = false
) {
  const newFilterOptions = [...selectedFilterOptions]

  const filterOptionIndex = selectedFilterOptions.findIndex(
    option =>
      option.type?.toLowerCase() === fitAttribute?.toLowerCase() &&
      (!allowMultiple ||
        option.value?.toLowerCase() === selectedOption?.toLowerCase())
  )

  const newFilterOption = {
    type: fitAttribute,
    position:
      1 +
      ORDERED_OPTIONS.findIndex(
        fitType => fitAttribute === fitType.toLowerCase()
      ),
    value: selectedOption.replace(BUILD, '').trim()
  }
  if (filterOptionIndex === -1) {
    newFilterOptions.push(newFilterOption)
  } else if (allowMultiple) {
    newFilterOptions.splice(filterOptionIndex, 1)
  } else if (
    newFilterOptions[filterOptionIndex].value?.toLowerCase() ===
    selectedOption?.toLowerCase()
  ) {
    newFilterOptions.splice(filterOptionIndex, 1)
  } else {
    newFilterOptions[filterOptionIndex] = { ...newFilterOption }
  }
  return newFilterOptions
}

export const filterByProductFeed = (
  collections: Collection[],
  productStyle: string,
  type = 'style'
) => {
  return collections
    .map(collection => {
      const items = collection.items.filter(item => {
        if (type === 'style') {
          return [item.product_feed.style?.toLowerCase()].includes(
            productStyle.toLowerCase()
          )
        }
        if (type === 'group') {
          return [
            item.product_feed.ecom_product_grouping?.toLowerCase()
          ].includes(productStyle.toLowerCase())
        }
        return [item.product_feed.ecom_product_header?.toLowerCase()].includes(
          productStyle.toLowerCase()
        )
      })

      return { ...collection, items }
    })
    .filter(collection => collection.items.length > 0)
}

export const getAvailableProductStyles = (collections: Collection[]) => {
  const filtersByStyle = getProductFeedValues(collections, 'style')
  const newSetFilters = ['All', ...new Set(filtersByStyle)]

  return newSetFilters
}

export const getEcomProductCategoriesByType = (
  collections: Collection[],
  type: keyof ProductFeed
) => {
  const categories = getProductFeedValues(collections, type)

  return ['All', ...new Set(categories)]
}

const getProductFeedValues = (
  collections: Collection[],
  field: keyof ProductFeed
) => {
  const values = collections
    .flatMap(collection =>
      collection.items.map(item => item.product_feed[field])
    )
    .filter(Boolean)

  return values
}
